<template>
  <div class="form-group has-label">
    <label>Produkt</label>
    <multiselect :value="value"
      :options="products"
      track-by="real_barcode"
      :custom-label="nameWithBarcode"
      :allow-empty="true"
      :close-on-select="true"
      :searchable="true"
      :internal-search="false"
      :clear-on-select="false"
      @search-change="getProducts"
      @input="productSelected"
      placeholder="Produkt suchen..."
    >
      <template slot="noOptions">
        <div>Mindestens 3 Buchstaben eingeben um nach Produkten zu suchen</div>
      </template>
    </multiselect>
    <div class="text-danger invalid-feedback" style="display: block;"
      v-if="valError"
    >
      Produkt muss ausgewählt werden.
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
  props: {
    value: {
      default: null
    },
    valError: {
      default: ''
    },
    includeBoxes: {
      default: false
    }
  },
  data () {
    return {
      products: []
    }
  },
  methods: {
    productSelected (product) {
      this.$emit('input', product)
    },
    getProducts: debounce(function (query) {
      if (query.length >= 3) {
        this.isLoading = true
        const url = `/products?search=${encodeURIComponent(query)}${this.includeBoxes ? '&include_boxes=1' : ''}`
        this.$http.get(url).then(({ data }) => {
          this.products = data
          this.isLoading = false
        })
      }
    }, 300),
    nameWithBarcode (product) {
      return `${product.name} (${product.real_barcode})`
    }
  }
}
</script>

<style>
</style>
